import React, { useEffect, useState } from 'react';
import api from '../api';

export default function EmailAccounts() {
  const [doms, setDoms] = useState([]);
  const [accs, setAccs] = useState([]);
  const [f, setF] = useState({ domainId: '', username: '', password: '', quotaMb: 1024 });

  const load = async () => {
    const [a, b] = await Promise.all([api.get('/domains'), api.get('/email/accounts')]);
    setDoms(a.data.filter(d => d.has_email)); setAccs(b.data);
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    try { await api.post('/email/accounts', f); load(); setF({ domainId: '', username: '', password: '', quotaMb: 1024 }); }
    catch (e) { alert(e.response?.data?.error || 'Erro'); }
  };

  return (
    <>
      <div className="page-title"><h1>E-mail · Contas</h1></div>
      <table>
        <thead><tr><th>E-mail</th><th>Quota</th><th>Criado</th></tr></thead>
        <tbody>
          {accs.map(a => (
            <tr key={a.id}>
              <td>{a.username}@{a.domain_name}</td>
              <td>{a.quota_mb} MB</td>
              <td>{new Date(a.created_at).toLocaleString('pt-BR')}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <h3 style={{marginTop:'1.5rem'}}>Nova conta</h3>
      <div className="row">
        <select value={f.domainId} onChange={e=>setF({...f, domainId: e.target.value})}>
          <option value="">— domínio —</option>
          {doms.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
        </select>
        <input value={f.username} onChange={e=>setF({...f, username: e.target.value})} placeholder="usuario" />
        <input value={f.password} onChange={e=>setF({...f, password: e.target.value})} placeholder="senha" type="password" />
        <input value={f.quotaMb}  onChange={e=>setF({...f, quotaMb: +e.target.value})} placeholder="Quota MB" />
        <button onClick={add}>Criar</button>
      </div>
    </>
  );
}
